import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { MessageService } from '@doc/api/server-bo';
@Injectable({
  providedIn: 'root'
})

export class PermissionService {
  permissionMappings: any = {
    createUser: 1,
    readUser: 2,
    updateUser: 3,
    deleteUser: 4,
    createDocument: 5,
    readDocument: 6,
    updateDocument: 7,
    deleteDocument: 8,
    createFolder: 9,
    readFolder: 10,
    updateFolder: 11,
    deleteFolder: 12,
    createFile: 13,
    readFile: 14,
    updateFile: 15,
    deleteFile: 16
  };
  constructor(private authService: AuthenticationService, private messageService: MessageService) { }

  hasRolePermission(permission: string): boolean {
    if (this.authService.isFullAccess()) {
      return true;
    }
    const permissions = this.authService.getPermissions();
    const permissionId = this.permissionMappings[permission];
    return permissions.includes(permissionId);
  }

  checkPermission(type: string, item: any, action: string): boolean {
    let hasPermission = false;
    let detailMessage = '';

    switch (action) {
      case 'rename':
      case 'share':
        hasPermission = item?.permissions?.isUpdate || false;
        detailMessage = 'update or share';
        break;
      case 'open':
      case 'info':
      case 'view':
      case 'download':
        hasPermission = item?.permissions?.isRead || false;
        detailMessage = 'open, view details, or download';
        break;
      case 'remove':
        hasPermission = item?.permissions?.isDelete || false;
        detailMessage = 'delete';
        break;
      case 'create':
        hasPermission = item?.permissions?.isCreate || false;
        detailMessage = 'create new items';
        break;

    }
    hasPermission = true;
    if (!hasPermission) {
      this.messageService.add({
        severity: 'error',
        summary: 'Permission Denied',
        detail: `You do not have permission to ${detailMessage}.`
      });
    }

    return hasPermission;
  }

}
